import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import users from './users'
import parametros from './parametros'
import listadoPostulante from './postulante'
import registroPuestos from './registroPuestos'
import solicitudesListado from './solicitudesListado'
import acciones from './accionesIndependientes'
import renovaciones from './Renovaciones'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  

  },
  getters: {
 
  },
  mutations: {
   
  },
  actions: {
   
  },
  modules: {
    auth,
    users,
    parametros,
    listadoPostulante,
    registroPuestos,
    solicitudesListado,
    acciones,
    renovaciones
  }
})
